import { c as _c } from "react/compiler-runtime";
import { FormInput, toast } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import axios from 'axios';
import { DigitalProductBase } from 'modules/digital-product/components/digital-product-base';
import { DigitalProductSave } from 'modules/digital-product/components/digital-product-save';
import { defaultDigitalProductErrors, defaultDigitalProductValues } from 'modules/digital-product/constants/default-values';
import { DigitalProductTabEnum } from 'modules/digital-product/enums/digital-product-tab-enum';
import { useDigitalProductActions } from 'modules/digital-product/hooks/use-digital-product-actions';
import { useDigitalProductsList } from 'modules/digital-product/hooks/use-digital-product-list';
import PricePlans from 'modules/digital-product/price-plans';
import { PricePlanType } from '@systemeio/types';
import Resources from 'modules/digital-product/resources';
import { DigitalProductChangeInterface, DigitalProductErrorInterface, DigitalProductInterface } from 'modules/digital-product/types/digital-product-interface';
import { getDigitalProductApiData } from 'modules/digital-product/utils/get-digital-product-api-data';
import { DigitalOfferEditInterface } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/digital-offer-interface';
import React, { FC, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { DigitalProductProps } from '../index';
import { CloseIcon } from '@systemeio/ui/icons';
interface BaseProps extends Omit<DigitalProductProps, 'product' | 'onSave'> {
  setTab: (tab: DigitalProductTabEnum) => void;
}
type DigitalProductEditProps = BaseProps & {
  onSave?: never;
  digitalProduct: DigitalProductInterface;
};
type DigitalProductCreateProps = BaseProps & {
  onSave: (data: DigitalOfferEditInterface['digitalProduct']) => Promise<void>;
  digitalProduct?: never;
};
type Props = DigitalProductEditProps | DigitalProductCreateProps;
const inCreate = (props: Props): props is DigitalProductCreateProps => !!props.onSave;
const DigitalProductEdit: FC<Props> = props => {
  const $ = _c(55);
  let t0;
  if ($[0] !== props) {
    t0 = inCreate(props);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isCreate = t0;
  const {
    mutate
  } = useDigitalProductsList(props.currency, props.source);
  const {
    t
  } = useLocoTranslation();
  const [isFetching, setIsFetching] = useState(false);
  const [tempState, setTempState] = useState(isCreate ? defaultDigitalProductValues : props.digitalProduct);
  const [errors, setErrors] = useState(defaultDigitalProductErrors);
  const {
    onCreate,
    onEdit
  } = useDigitalProductActions();
  let t1;
  if ($[2] !== mutate) {
    t1 = async digitalProduct => mutate(data => data && data.map(el => el.id === digitalProduct.id ? digitalProduct : el), false);
    $[2] = mutate;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const mutateDigitalProductItemFromList = t1;
  let t2;
  if ($[4] !== isCreate || $[5] !== mutate || $[6] !== mutateDigitalProductItemFromList || $[7] !== onCreate || $[8] !== onEdit || $[9] !== props || $[10] !== t || $[11] !== tempState) {
    t2 = async () => {
      ;
      try {
        setErrors(defaultDigitalProductErrors);
        setIsFetching(true);
        if (isCreate) {
          const digitalProduct_0 = await onCreate(getDigitalProductApiData(tempState, props.source));
          await mutate(data_0 => data_0 && [...data_0, digitalProduct_0], false);
          await props.onSave(digitalProduct_0.id);
        } else {
          const responseData = await onEdit(props.digitalProduct.id, getDigitalProductApiData(tempState, props.source));
          await mutateDigitalProductItemFromList(responseData);
        }
        toast.success(t("global.changes_saved"));
        props.setTab(DigitalProductTabEnum.select);
        setIsFetching(false);
      } catch (t3) {
        const e = t3;
        if (axios.isCancel(e)) {
          return;
        }
        setIsFetching(false);
        if (e instanceof BadRequest) {
          if (e.errors.fields) {
            const errors_0 = e.errors.fields as DigitalProductErrorInterface;
            setErrors(prev => ({
              ...prev,
              ...errors_0
            }));
          }
        }
      }
    };
    $[4] = isCreate;
    $[5] = mutate;
    $[6] = mutateDigitalProductItemFromList;
    $[7] = onCreate;
    $[8] = onEdit;
    $[9] = props;
    $[10] = t;
    $[11] = tempState;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const onSaveDigitalProduct = t2;
  const isReadyToSave = !!tempState.name && tempState.pricePlans.length > 0;
  let t3;
  if ($[13] !== isCreate || $[14] !== mutateDigitalProductItemFromList || $[15] !== props.digitalProduct) {
    t3 = !isCreate ? async pricePlans => {
      await mutateDigitalProductItemFromList({
        ...props.digitalProduct,
        pricePlans
      });
    } : undefined;
    $[13] = isCreate;
    $[14] = mutateDigitalProductItemFromList;
    $[15] = props.digitalProduct;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  const mutatePricePlans = t3;
  let t4;
  if ($[17] !== props) {
    t4 = () => props.setTab(DigitalProductTabEnum.select);
    $[17] = props;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CloseIcon />;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== t4) {
    t6 = <DigitalProductBase additionalChild={<button onClick={t4} className="outline-hidden">{t5}</button>} />;
    $[20] = t4;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  const t7 = tempState.name;
  let t8;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = e_0 => setTempState(prev_0 => ({
      ...prev_0,
      name: e_0.target.value
    }));
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t) {
    t9 = t("dashboard.funnel.configuration.offer.digital_product_name");
    $[23] = t;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== errors.name || $[26] !== t9 || $[27] !== tempState.name) {
    t10 = <FormInput className="sm:min-w-0" value={t7} onChange={t8} label={t9} error={errors.name} />;
    $[25] = errors.name;
    $[26] = t9;
    $[27] = tempState.name;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = resources => setTempState(prev_1 => ({
      ...prev_1,
      resources
    }));
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== errors.resources || $[31] !== tempState.resources) {
    t12 = <Resources resources={tempState.resources} errors={errors.resources} onChangeResources={t11} />;
    $[30] = errors.resources;
    $[31] = tempState.resources;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <hr className="border-t-1 border-text-secondary/30 border-solid" />;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  const t14 = props.isBump ? 1 : Infinity;
  let t15;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = pricePlans_0 => setTempState(prev_2 => ({
      ...prev_2,
      pricePlans: pricePlans_0
    }));
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== errors.pricePlans || $[36] !== mutatePricePlans || $[37] !== props.currency || $[38] !== props.paymentMethods || $[39] !== t14 || $[40] !== tempState.pricePlans) {
    t16 = <PricePlans errors={errors.pricePlans} maxPricePlans={t14} paymentMethods={props.paymentMethods} currency={props.currency} pricePlans={tempState.pricePlans} onChanePricePlans={t15} mutatePricePlans={mutatePricePlans} />;
    $[35] = errors.pricePlans;
    $[36] = mutatePricePlans;
    $[37] = props.currency;
    $[38] = props.paymentMethods;
    $[39] = t14;
    $[40] = tempState.pricePlans;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== t12 || $[43] !== t16) {
    t17 = <div className="ml-5 flex flex-col gap-5">{t12}{t13}{t16}</div>;
    $[42] = t12;
    $[43] = t16;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  const t18 = !isReadyToSave;
  let t19;
  if ($[45] !== isCreate || $[46] !== isFetching || $[47] !== onSaveDigitalProduct || $[48] !== t18) {
    t19 = <DigitalProductSave isFetching={isFetching} onSave={onSaveDigitalProduct} isCreate={isCreate} disabled={t18} />;
    $[45] = isCreate;
    $[46] = isFetching;
    $[47] = onSaveDigitalProduct;
    $[48] = t18;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== t10 || $[51] !== t17 || $[52] !== t19 || $[53] !== t6) {
    t20 = <>{t6}{t10}{t17}{t19}</>;
    $[50] = t10;
    $[51] = t17;
    $[52] = t19;
    $[53] = t6;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  return t20;
};
export default DigitalProductEdit;